import { lazy, Suspense } from "react";

/// Components
import Index from "./admin/jsx";
import { connect } from "react-redux";
import {
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
// action
import {
  //checkAutoLogin,
  isLogin,
} from "./admin/services/Auth/AuthService";
import { isAuthenticated } from "./admin/store/selectors/AuthSelectors";
/// Style
import "./admin/css/style.css";
import "./admin/jsx/Css/CustomCss.css";
import "./admin/jsx/components/Modal/AddServiceProvider.css";
import OtpLogin from "./admin/jsx/pages/OTP";
const ForgotPassword = lazy(() => import("./admin/jsx/pages/ForgotPassword"));
const Login = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import("./admin/jsx/pages/Login")), 500);
  });
});

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();

    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

function App(props) {
  // const dispatch = useDispatch();
  // const navigate = useNavigate();
  // useEffect(() => {
  //    checkAutoLogin(dispatch, navigate);
  // }, []);

  const location = useLocation();
  let currentPath = location.pathname;
  currentPath = currentPath.replace("/", "");
  currentPath = currentPath.replace("/\\/g", "");

  let pagesList = [
    "",
    "front-dashboard",
    "front-transactions",
    "front-booking",
    "front-orders_status",
    "front-people",
    "front-wallet",
    "front-food-items",
    "front-reviews",
    "front-authentication",
    "front-support",
    "front-terms_conditions",
    "front-setting",
  ];

  let cssId = document.getElementById("MainStyleSheet");
  let currentCSSPath = cssId.getAttribute("href");

  let frontendCSSPath = "/react/demo/css/frontend/css/frontend-style.css";
  let adminCSSPath = "/react/demo/css/admin/css/admin-style.css";

  if (pagesList.indexOf(currentPath) > -1) {
    if (currentCSSPath != frontendCSSPath) {
      cssId.setAttribute("href", frontendCSSPath);
    }
  } else if (currentCSSPath != adminCSSPath) {
    cssId.setAttribute("href", adminCSSPath);
  }

  let routeblog = (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/page-forgot-password" element={<ForgotPassword />} />

      <Route path="/*" replace element={<Login />} />
      <Route path="/otp" replace element={<OtpLogin />} />
    </Routes>
  );
  if (isLogin()) {
    // if (props.isAuthenticated) {
    return (
      <>
        <Suspense
          fallback={
            <div id="preloader">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          }
        >
          <Index exact />
        </Suspense>
      </>
    );
  } else {
    return (
      <div className="vh-100">
        <Suspense
          fallback={
            <div id="preloader">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          }
        >
          {routeblog}
        </Suspense>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
  };
};

export default withRouter(connect(mapStateToProps)(App));
